module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/toner@3x_3e8c0a.png";